import { useEffect } from 'react';
import { dashboardApi } from '../services/api';

/**
 * Hook that sends session heartbeats to track active users.
 * Sends immediately on mount, then every 2 minutes.
 */
export function useSessionHeartbeat() {
  useEffect(() => {
    // Send immediately
    dashboardApi.heartbeat();

    // Send every 2 minutes
    const interval = setInterval(() => {
      dashboardApi.heartbeat();
    }, 2 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);
}
